/**
 * Promeal Cibus Checkout
 * Fetches cart, collects shipping info, POSTs to App Proxy, redirects to PayPlus.
 */
(function () {
  'use strict';

  function init() {
    if (window.cibusCheckoutInitialized) return;
    window.cibusCheckoutInitialized = true;

    var form = document.getElementById('cibus-checkout-form');
    if (!form) {
      console.error('Cibus checkout: form not found');
      return;
    }

    var submitBtn = document.getElementById('cibus-submit-btn');
    var summaryEl = document.getElementById('cibus-cart-summary');
    var totalEl = document.getElementById('cibus-cart-total');

    function formatMoney(cents) {
      return (cents / 100).toFixed(2) + ' ₪';
    }

    function renderCartSummary(cart) {
      if (!summaryEl) return;
      var html = '';
      cart.items.forEach(function (item) {
        html += '<div class="cibus-checkout__line">';
        html += '<span>' + (item.product_title || item.title) + ' × ' + item.quantity + '</span>';
        html += '<span>' + formatMoney(item.line_price || item.price * item.quantity) + '</span>';
        html += '</div>';
      });
      summaryEl.innerHTML = html;
      if (totalEl) {
        totalEl.textContent = formatMoney(cart.total_price);
      }
    }

    function validate() {
      var required = form.querySelectorAll('[required]');
      var firstInvalid = null;
      required.forEach(function (input) {
        var wrap = input.closest('[data-cibus-field]');
        if (!input.value.trim()) {
          if (wrap) wrap.classList.add('cibus-checkout__field--error');
          if (!firstInvalid) firstInvalid = input;
        } else if (wrap) {
          wrap.classList.remove('cibus-checkout__field--error');
        }
      });
      if (firstInvalid) {
        firstInvalid.focus();
        return false;
      }
      return true;
    }

    form.querySelectorAll('input, select').forEach(function (input) {
      input.addEventListener('input', function () {
        var wrap = this.closest('[data-cibus-field]');
        if (wrap) wrap.classList.remove('cibus-checkout__field--error');
      });
    });

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) {
          if (summaryEl) {
            summaryEl.innerHTML = '<p class="cibus-checkout__empty">העגלה ריקה. <a href="/">חזרו לחנות</a></p>';
          }
          if (submitBtn) submitBtn.disabled = true;
          return;
        }
        renderCartSummary(cart);
      })
      .catch(function (err) {
        console.error('Cibus checkout: failed to load cart', err);
        if (summaryEl) {
          summaryEl.innerHTML = '<p class="cibus-checkout__empty">שגיאה בטעינת העגלה. רענו את הדף.</p>';
        }
      });

    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      if (!validate()) return;

      var btnOrigText = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'מעבד...';
      }

      try {
        var cartRes = await fetch('/cart.js');
        var cart = await cartRes.json();

        if (!cart.items || !cart.items.length) {
          alert('העגלה ריקה. הוסיפו מוצרים ונסו שוב.');
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = btnOrigText;
          }
          return;
        }

        var formData = new FormData(form);
        var shipping = {};
        formData.forEach(function (value, key) { shipping[key] = value; });

        var shippingCents = parseInt(form.getAttribute('data-shipping-cents') || '0', 10);

        var res = await fetch('/apps/cibus-checkout', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            cart: cart,
            shipping: shipping,
            shipping_cost_agorot: shippingCents
          })
        });

        var raw = await res.text();
        var data = {};
        try {
          data = raw ? JSON.parse(raw) : {};
        } catch (parseErr) {
          console.error('Cibus checkout non-JSON response:', res.status, raw);
          throw new Error('Server returned non-JSON (' + res.status + ')');
        }

        if (data.payment_page_link) {
          window.location.href = data.payment_page_link;
        } else {
          alert(data.error || ('שגיאה ביצירת קישור תשלום (' + res.status + '). נסו שוב.'));
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = btnOrigText;
          }
        }
      } catch (err) {
        console.error('Cibus checkout error:', err);
        alert((err && err.message) || 'שגיאת תקשורת. בדקו את החיבור לאינטרנט ונסו שוב.');
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = btnOrigText;
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
